import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "price_details" } },
    [
      _vm.isClubEnabled
        ? [
            _c(_setup.ClubPriceDetails, {
              staticClass: "px-5 py-6",
              attrs: {
                "full-price": _vm.fullPrice,
                "total-price": _vm.totalPrice,
                "card-price": _vm.cardPrice,
                "is-no-card": _vm.isNoCard,
              },
            }),
            _vm._v(" "),
            _c(VDivider),
            _vm._v(" "),
            _c(_setup.ClubPricePrettyDetails, {
              staticClass: "pa-5",
              attrs: {
                "lpu-price": _vm.lpuPrice,
                "option-price": _vm.optionPrice,
                "card-price": _vm.cardPrice,
                "is-no-card": _vm.isNoCard,
              },
            }),
          ]
        : _c(_setup.CommonPriceDetails, {
            staticClass: "px-5",
            attrs: { "full-price": _vm.fullPrice },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }